import { lang } from '@umu/ukit-lang';
/**
 * @description 密码输入框，带显示明文密码的功能
 * @author wayou
 */

import './passwordInput.scss';

import React, { Component, createRef, RefObject } from 'react';
import { classSet } from '@umu/umu-dom';

interface IProps {
    clsName?: string;
    inputType?: string;
    placeholder: string;
    changeCallback: (val: string) => void;
}

class PasswordInput extends Component<IProps> {

    public static defaultProps = {
        inputType: 'password',
        placeholder: lang('请输入密码，不少于6位'),
    };

    public elRef: RefObject<HTMLInputElement>;
    public iconRef: RefObject<HTMLDivElement>;

    constructor(props: IProps) {
        super(props);

        this.elRef = createRef();
        this.iconRef = createRef();

        this.inputChangeCallback = this.inputChangeCallback.bind(this);
        this.switchPasswordType = this.switchPasswordType.bind(this);
        this.onPaste = this.onPaste.bind(this);
    }

    public getClassName(clsName?: string) {
        let classObj = {
            'password-wrap': true,
            'input lined': true,
        };
        if (clsName) {
            classObj = Object.assign(classObj, {
                [clsName]: true,
            });
        }
        return classSet(classObj);
    }

    public switchPasswordType() {
        const passwordInput = this.elRef.current;
        if (!passwordInput) {
            return;
        }

        if (passwordInput.type === 'password') {
            passwordInput.type = 'text';
        } else {
            passwordInput.type = 'password';
        }

        const iconRef = this.iconRef.current;
        if (!iconRef) {
            return;
        }
        // IE9 fix
        if (iconRef.classList) {
            iconRef.classList.toggle('close');
        } else {
            iconRef.className.indexOf('close') > -1 ? iconRef.className = iconRef.className.replace('close', '')
                : iconRef.className += ' close';
        }
        // event.currentTarget.classList.toggle('close');
    }

    public inputChangeCallback() {
        const el = this.elRef.current;
        if (!el) {
            return;
        }

        const val = el.value || '';
        this.props.changeCallback(val);
    }

    public onPaste(e: React.ClipboardEvent<HTMLInputElement>) {
        const val = e.clipboardData.getData('Text');
        this.props.changeCallback(val);
    }

    public render() {
        const props = this.props;

        return (
            <div className={this.getClassName(props.clsName)}>
                <a className="toggle-visible-wrap" onClick={this.switchPasswordType}>
                    <i className="icon icon-entity entity-password-switch" ref={this.iconRef} ></i>
                </a>
                <input type={props.inputType}
                    ref={this.elRef}
                    placeholder={props.placeholder}
                    onKeyUp={this.inputChangeCallback}
                    onPaste={this.onPaste} />
            </div>
        );
    }
}

export default PasswordInput;
